import * as React from 'react'

const SvgUploadIcon = ({ props = {} }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.3333 4.16602L14.8333 1.66602M14.8333 1.66602L17.3333 4.16602M14.8333 1.66602V6.66602M9.41667 2.49935H5.5C4.09987 2.49935 3.3998 2.49935 2.86502 2.77183C2.39462 3.01152 2.01217 3.39397 1.77248 3.86437C1.5 4.39915 1.5 5.09922 1.5 6.49935V13.4993C1.5 14.8995 1.5 15.5995 1.77248 16.1343C2.01217 16.6047 2.39462 16.9872 2.86502 17.2269C3.3998 17.4993 4.09987 17.4993 5.5 17.4993H13.1667C13.9416 17.4993 14.3291 17.4993 14.647 17.4142C15.5098 17.183 16.1836 16.5091 16.4148 15.6464C16.5 15.3285 16.5 14.941 16.5 14.166M7.75 7.08268C7.75 8.00316 7.00381 8.74935 6.08333 8.74935C5.16286 8.74935 4.41667 8.00316 4.41667 7.08268C4.41667 6.16221 5.16286 5.41602 6.08333 5.41602C7.00381 5.41602 7.75 6.16221 7.75 7.08268ZM11.4917 9.93114L4.44262 16.3394C4.04614 16.6998 3.84789 16.8801 3.83036 17.0362C3.81516 17.1715 3.86704 17.3057 3.96932 17.3956C4.08732 17.4993 4.35523 17.4993 4.89107 17.4993H12.7133C13.9126 17.4993 14.5123 17.4993 14.9833 17.2979C15.5745 17.0449 16.0456 16.5739 16.2985 15.9826C16.5 15.5116 16.5 14.912 16.5 13.7127C16.5 13.3091 16.5 13.1074 16.4559 12.9195C16.4005 12.6833 16.2941 12.4621 16.1444 12.2713C16.0252 12.1195 15.8677 11.9935 15.5526 11.7414L13.2215 9.87657C12.9062 9.62427 12.7485 9.49813 12.5748 9.45361C12.4218 9.41437 12.2607 9.41945 12.1104 9.46826C11.94 9.52363 11.7905 9.65947 11.4917 9.93114Z"
      stroke="#475467"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SvgUploadIcon
